import {
    Checkbox,
    CheckboxProps,
    FormControl,
    FormControlLabel,
    FormHelperText,
    styled
} from '@mui/material';
import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import { observer } from 'mobx-react';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';

import { Step2Store } from '../../step-2/store';

const StyledHelperText = styled(FormHelperText)(({ theme }) => ({
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(1)
}));

const StyledMarkdownLabel = styled(ReactMarkdown)(({ theme }) => ({
    '& a': {
        color: theme.palette.primary.main,
        textDecoration: 'none'
    }
}));

const ProcessingOptIn = observer((props: CheckboxProps) => {
    const { translate } = injectTSDI(I18nStore);

    const signupForm = injectTSDI(Step2Store);
    const {
        processingOptIn: { value, error, onChange }
    } = signupForm.form.$;

    return (
        <FormControl error={Boolean(error)} required>
            <div>
                <FormControlLabel
                    control={
                        <Checkbox
                            inputProps={
                                {
                                    'data-role': 'processing-checkbox',
                                    checked: value
                                } as React.InputHTMLAttributes<HTMLInputElement>
                            }
                            id="processingOptIn"
                            checked={value}
                            onChange={(e) => onChange(e.target.checked)}
                            name="processingOptIn"
                            size="medium"
                            color="primary"
                            {...props}
                        />
                    }
                    label={
                        <StyledMarkdownLabel linkTarget="_blank">
                            {`${translate(
                                'signup.processing.consent.labelv2'
                            )} *`}
                        </StyledMarkdownLabel>
                    }
                />
            </div>
            <StyledHelperText>{error ? error : ' '}</StyledHelperText>
        </FormControl>
    );
});

export default ProcessingOptIn;
